<template>
  <div class="help_home_layout">
    <Layout style="height: 100%">
      <Header>
        <helpHeader :IsHome="true" @searchData="searchFilter"></helpHeader>
      </Header>
      <Layout>
        <Sider hide-trigger collapsible :style="{ height: '100vh' }">
          <!-- <Tree
            class="tree"
            :data="data"
            expand-node
            @on-select-change="selectChange"
          ></Tree> -->

          <Menu  accordion @on-select="handleSelect" style="width: 200px; min-width: 200px; max-width: 200px;height: 100vh;">
              <Submenu :name="item.id" v-for="(item,index) in data" :key='index'>
                  <template slot="title">
                      {{item.name}}
                  </template>
                  <MenuItem :name="v.id" v-for="(v,k) in item.children" :key='k'>{{v.name}}</MenuItem>
              </Submenu>
            </Menu>
        </Sider>
        <Content>
          <div class="content">
            <router-view v-if="RouterState"></router-view>
          </div>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import helpHeader from "@/components/help-header";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    helpHeader,
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      showSearch: false,
      searchData: "",
      data: [],
      RouterState: true,
      catID :null
    };
  },
  mounted() {
    let params = this.$route.params.search;
    this.catID = this.$route.params.catID;
    console.log("筛选一级分类ID", this.catID);

    if (params) {
      this.$router.push({ name: "help_list", params: { search: params } });
    }
    this.getData(this.catID);
  },
  methods: {
    ...mapActions(["GetDocsCat"]),
    getData(cat) {
      this.GetDocsCat().then((res) => {
        if (res.status) {
          res.data.map((item) => {
            if (!item.children) {
              item.children = [];
            }
            //判断是否有选择分类
            if (cat && cat == item.id) {
              item.expand = true;
              if (item.children.length) {
                this.toHelpList(item.name + "/" + item.children[0].name,item.id,item.children[0].id);
              }
            }
          });
          this.data = res.data;
        }
      });
    },
    //搜索
    searchFilter(data) {
      console.log("搜索值", data);
    },
    searchClose() {
      this.showSearch = false;
      this.searchData = "";
    },
    handleSelect(e){
      let parentName = "",name='',parentId;
      this.data.map(item=>{
        item.children.map(v=>{
          if(v.id == e){
            name = v.name;
            parentName = item.name
            parentId = item.id;
          }
        })
      })
      this.toHelpList(parentName + "/" + name,parentId,e);
    },
    toHelpList(title,parentId,cat) {
      this.$router.push({
        path: "/help/list",
        query: { title,parentId,cat },
      });
      setTimeout(() => {
        this.reload();
      }, 500);
    },
    reload() {
      this.RouterState = false;
      this.$nextTick(() => {
        this.RouterState = true;
      });
    },
  },
};
</script>
<style lang="less">
@import "./home.less";
.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active{
  color: #E8244A !important;
  font-weight: bold;
}
</style>
